// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mjIo","textarea":"styles_textarea__36_La"};